import React from 'react';
import get from 'lodash/get';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import moment from 'moment';
import { limitText } from '../../../components/LatestNewsSection/utils';
import { FormattedMessage } from '../../../util/reactIntl';
import NewsImage from '../../../components/NewsImage/NewsImage';
import NewsLink from '../../../components/NewsLink/NewsLink';
import { IconEdit, IconDelete } from '../../../components';

import css from './PostsSection.module.scss';

const YESTERDAY = Date.now()-86400000;

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

const Events = props => {

  const {
    events,
    handleEditPopup,
    isOwnListing,
    isPreview,
    intl
  } = props;

  if(!events?.length) return null;

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 1.3 : 2.3;

  const actualEvents = events.filter(e => new Date(e?.eventDate?.date).getTime() > YESTERDAY)
  .sort((a, b) => new Date(a?.eventDate?.date).getTime() - new Date(b?.eventDate?.date).getTime());
  const pastEvents = events.filter(e => new Date(e?.eventDate?.date).getTime() < YESTERDAY);

  const profileEvents = [...actualEvents, ...pastEvents];

  return (
    <>
      {!!profileEvents?.[0] && (
        <div className={css.wrapper} key="eventsSwiper">
          <h2 className={css.descriptionTitle}>
            <FormattedMessage id="ListingPage.eventsTitle" />
          </h2>
          <div className={css.newsWrapper}>

            <Swiper
              modules={[Navigation]}
              navigation={{
                nextEl: '.custom_next',
                prevEl: '.custom_prev',
              }}
              spaceBetween={10}
              slidesPerView={slidesToShow}
              onSwiper={swiper => { }}
              onSlideChange={() => { }}
            >
              <div className="custom_next">
                <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
              </div>
              <div className="custom_prev">
                <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
              </div>
              {profileEvents.map((e, index) => {
                const title = get(e, 'title', '');
                const discountCode = get(e, 'discountCode', '');
                const link = get(e, 'link', null);
                const imgUrl = get(e, 'image.url', null);

                const isPastEvent = YESTERDAY > new Date(e?.eventDate?.date).getTime();

                return (
                  <SwiperSlide key={`${e.title}-${index}`}>

                    <div key={index?.toString()} className={css.newsItem}>
                      {isOwnListing && (
                        <div className={css.actionButtons}>

                          {!isPastEvent && (
                            <div
                              className={css.actionButton}
                              onClick={() => isPreview ?
                                alert(intl.formatMessage({ id: 'PreviewPopup.previewMode' })) :
                                handleEditPopup(true, false, 'events', index)}>
                              <IconEdit size="big" />
                            </div>
                          )}

                          <span
                            className={css.actionButton}
                            onClick={() => isPreview ?
                              alert(intl.formatMessage({ id: 'PreviewPopup.previewMode' })) :
                              handleEditPopup(false, true, 'events', index)}
                          >
                            <IconDelete />
                          </span>
                        </div>
                      )}
                      <div className={css.titleWrapper}>
                        {link ? (
                          <NewsLink
                            className={css.title}
                            link={link}
                          >
                            {title}
                          </NewsLink>
                        ) : (
                          <span className={css.title}>
                            {title}
                          </span>
                        )}
                      </div>
                      <NewsImage
                        imgUrl={imgUrl}
                        link={link}
                        imageClassName={css.image}
                        iconClassName={css.newsIcon}
                      />
                      {isPastEvent ? <FormattedMessage id="ListingPage.pastEvent" /> : (
                        <>
                          <p className={css.description}>{moment(e?.eventDate?.date).format('ddd, MMM D, YYYY')}</p>
                          {discountCode && <div className={css.discountCode}>Discount code: {discountCode}</div>}
                        </>
                      )}
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
};

export default Events;
